/**
 * /system-admin/settings — platform settings page (root-only).
 *
 * Guard strategy: dual-layer.
 *   1. beforeLoad: requireRoot() — synchronous redirect before mount so the
 *      query in SettingsForm never fires for non-root admins.
 *   2. SystemAdminGuard requireRoot — renders skeleton while auth hydrates,
 *      then redirects if still no access (handles cold-load race).
 */

import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { Settings } from "lucide-react";
import { PageHeader } from "@/components/ui/page-header";
import { requireRoot } from "@/lib/auth/require-root";
import { SystemAdminGuard } from "@/features/system-admin/components/system-admin-guard";
import { SettingsForm } from "@/features/system-admin/components/settings/settings-form";

export const Route = createFileRoute("/system-admin/settings")({
  beforeLoad: () => {
    requireRoot();
  },
  component: SystemAdminSettingsPage,
});

function SystemAdminSettingsPage() {
  const t = useTranslations("system-admin.common");

  return (
    <SystemAdminGuard requireRoot>
      <div className="space-y-6">
        <PageHeader
          icon={Settings}
          title={t("pages.settings.title")}
          description={t("pages.settings.subtitle")}
        />
        <SettingsForm />
      </div>
    </SystemAdminGuard>
  );
}
